import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";
import { GameState } from "../objects/GameState";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.RocketRepair;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "RocketRepair.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "RocketRepair.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "RocketRepair.Phaser.HowToPlay.tabletInstructions";

        GameState.current = new GameState();
    }
}



// WEBPACK FOOTER //
// ./src/games/RocketRepairGame/scenes/IntroductionScene.ts